import { IResponse } from "@app/common/types/http";
import { HTTP_DISPENSARY } from "@app/config/axios";
import { AnnulDeliveryPayload, PharmacyControlFilter, PharmacyControlResponse } from "./types";
import { clearEmptyKeys } from "@app/common/utils/utils";

export async function pharmacyControlService(filters: PharmacyControlFilter, token: string) {
  const res = await HTTP_DISPENSARY(token).get<IResponse<PharmacyControlResponse[]>>(
    "/dispensaries/complete/",
    { params: clearEmptyKeys(filters) }
  );
  return res.data;
}

export const downloadPharmacyControlExcel = async (
  filters: PharmacyControlFilter,
  token: string
) => {
  const res = await HTTP_DISPENSARY(token).get<IResponse<{ base64: string }>>(
    "/dispensaries/complete-excel",
    { params: filters }
  );

  return res.data;
};

export const deleteDispensaryService = async (dispensaryId: number, token: string) => {
  const res = await HTTP_DISPENSARY(token).delete<IResponse<null>>(`/dispensaries/${dispensaryId}`);

  return res.data;
};

export const requestAnnulDeliveryService = async (payload: AnnulDeliveryPayload, token: string) => {
  const res = await HTTP_DISPENSARY(token).post<IResponse<null>>(
    "/request-annul-delivery/",
    payload
  );

  return res.data;
};
